import UI from 'editor-ui-lib';
import Wix from 'Wix';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components'

// const UntouchableSection = styled.div`
//     position: absolute;
//     top: 0px;
//     /* right: 109px; */
//     width: 100%;
//     height: 100%;
//     background-color: rgba(255,255,255,0.5);
//     /* z-index: 1000; */
// `
// const Tooltip = styled.div`
//     position: absolute;
//     left: 50%;
//     /* top: 1px; */
//     top: 50%;
//     transform: translate(-50%, -50%);
//     svg {
//         width: 50px;
//         height: 50px;
//     }
// `

// const None = styled.div`
//     display: none;
// `

const FadeArea = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: ${props => props.hideFade ? 'transparent' : 'rgba(255,255,255,.5)' } ;
    pointer-events: ${props => props.blockClicks ? 'auto' : 'none' };
    ${props => props.blockClicks ? 'cursor: auto;' : '' }
    z-index: 1;
`
const IconWrapper = styled.div`
    position: absolute;
    cursor: pointer;
    pointer-events: auto;
    ${props => props.iconSize ? `svg{ width: ${props.iconSize}px; height: ${props.iconSize}px;}` : ''}
`

class PremiumIcon extends React.Component {
    constructor(props) {
        super(props);
    }

    openBillingPage() {
        Wix.Dashboard.openBillingPage();
    }

    render() {
        return (
            <FadeArea className={'fade'} style={this.props.fadeStyles} blockClicks={this.props.blockClicks} hideFade={this.props.hideFade}
                onClick={ e => {
                    if (this.props.blockClicks) {
                        e.stopPropagation()
                    }
                }}
                onMouseDown={ e => {
                    if (this.props.blockClicks) {
                        e.stopPropagation()
                    }
                }}
            
            >
                {!this.props.hideIcon && 
                    <IconWrapper className={'fade'} style={this.props.iconStyles} iconSize={this.props.iconSize} >
                        <UI.tooltip width={'280px'} value={'To use this feature on published site upgrade to premium'} alignment="bottom">
                            <UI.symbol onClick={() => { this.openBillingPage() }} name="premiumLarge" />
                        </UI.tooltip>
                    </IconWrapper>
                }
            </FadeArea>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(mapStateToProps)(PremiumIcon);